import * as React from 'react';
import { SVGProps } from 'react';

const SvgNorecommendation = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <rect width={32} height={32} rx={16} fill="#D5DBDF" />
    <path
      d="M8.46 20h1.256v-4.956h.024L13.183 20h1.123v-7.046h-1.25v4.937h-.03l-3.432-4.937H8.46V20Zm9.42-7.046h-1.104l-1.845 8.755h1.098l1.85-8.755ZM18.53 20h1.26v-2.637h1.361L22.538 20h1.436l-1.538-2.827c.82-.298 1.328-1.065 1.328-2.012v-.01c0-1.362-.918-2.197-2.422-2.197h-2.813V20Zm1.26-3.633v-2.392h1.396c.79 0 1.289.449 1.289 1.186v.01c0 .757-.47 1.196-1.265 1.196h-1.42Z"
      fill="#174174"
    />
  </svg>
);

export default SvgNorecommendation;
